import React, {
	type PropsWithChildren,
	createContext,
	useState,
	useMemo,
	useContext,
	useCallback,
} from 'react';
import type { DependencyModalData, ModalContext } from './types.tsx';

const Context = createContext<ModalContext>({
	data: undefined,
	// Replace with lodash/noop
	// eslint-disable-next-line @typescript-eslint/no-empty-function
	openModal: () => {},
	// Replace with lodash/noop
	// eslint-disable-next-line @typescript-eslint/no-empty-function
	closeModal: () => {},
});

export const DependencyModalProvider = ({ children }: PropsWithChildren<{}>) => {
	const [data, setData] = useState<DependencyModalData | undefined>(undefined);

	const closeModal = useCallback(() => {
		setData(undefined);
	}, []);

	const value = useMemo(() => ({ data, openModal: setData, closeModal }), [data, closeModal]);

	return <Context.Provider value={value}>{children}</Context.Provider>;
};

export const useDependencyModalContext = (): ModalContext => useContext(Context);
